import { View } from 'backbone.marionette';
import { User } from '../../../models';
import { Secret } from "../../../utils";
const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);


/**
 * @desc Core RankingsTipping Row Class
 */
export class CoreRankingsRow extends View {
	ui() {
		return {
			'view_team': '.js-view-team'
		};
	}

	events() {
		return {
			'click @ui.view_team': 'viewTeam'
		}
	}

	regions() {
		return {
			'view_team': '.view-team'
		}
	}

	get className() {
		return 'table-row-item';
	}

	initialize() {
		const rounds = this.getOption( 'rounds' ),
			current_round = this.getOption( 'current_round' ),
			points_round = rounds.points_round,
			actual_round = points_round.get( 'id' );
		this.model
			.setAvatar()
			.set({
				is_preseason: IS_PRE_SEASON,
				current_round: current_round || actual_round,
				hidden_round_points: !current_round,
				points: this.model.get( 'league_points' ),
				scoreflow: this.model.get( 'league_scoreflow' ),
				current_user_id: User.get( 'id' ),
				actual_round
			})
			.updateLadderData();
	}

	viewTeam() {
		throw new Error( 'viewTeam is empty method. You can fill this method.' );
	}
}

export default CoreRankingsRow;